<div class="d-flex align-items-center">
    <div class='switch-container'>
        <input [id]="'cmn-toggle-reminder-switch-' + id" class="cmn-toggle cmn-toggle-flat cmn-toggle-rect-flat"
            type="checkbox" [disabled]="_disabled" [checked]="_bSwitchOn" (change)="turnOnOff($event.target.checked)">
        <label [for]="'cmn-toggle-reminder-switch-' + id">
            <span class="sr-only">Enable {{ _title }}</span>
        </label>
    </div>
    <div class="mx-2">{{ _title }}</div>
    <div *ngIf="_supportHint">
        <i [id]="'dropdown-reminder-switch-' + id" class="fas fa-info-circle" data-toggle="dropdown"></i>
        <div class="dropdown-menu pt-0 hint" data-backdrop="static" data-keyboard="false"
            [attr.aria-labelledby]="'dropdown-reminder-switch-' + id">
            <div class="mt-2">
                {{ _hintMsg }}
            </div>
        </div>
    </div>
    <button #btnPopup type="button" class="btn d-none" data-toggle="modal" data-target="#popupMsgModalHost"></button>
</div>
<div id="popupMsgModalHost" class="modal fade" data-backdrop="static" data-keyboard="false" role="dialog">
    <div class='modal-dialog config-dlg'>
        <div class='modal-content'>
            <div class='modal-header'>
                <span class="modal-title">Warning</span>
                <button #dlgClose type="button" class="close" data-dismiss="modal">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class='modal-body'>
                <div class="px-2 py-1">
                    {{ _popupMsg }}
                    <div class="mt-4 d-flex align-items-center">
                        <input [id]="'ch-reminder-enable-popup-' + id" type="checkbox" class="cmn-checkbox"
                            [checked]="!_supportPopup" (change)="disablePopupInFuture($event.target.checked)" />
                        <label [for]="'ch-reminder-enable-popup-' + id">
                            <svg>
                                <use xlink:href="#checkmark" />
                            </svg>
                        </label>
                        <span class="ml-2">Ignore the message in the future</span>
                    </div>
                </div>
                <div class='row control-block d-flex justify-content-center'>
                    <button type="button" class="btn btn-sm btn-action btn-light" data-dismiss="modal"
                        (click)="consentPopupMsg()">
                        <i class="fas fa-check mr-1"></i>
                        {{ 'key-ok' | translate | capitalFirstWord }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>